import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["_bodyElement", "bodyClassName", "name", "children"];
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { setupStyledComponents } from '../listeners/setupStyledComponents';
import ComponentWithBodyClass from '../utils/ComponentWithBodyClass';
import { AppProvider } from 'foundations-components';

/** @internal Hidden props - ask about your use case in #hds-support */
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIApplication(props) {
  const {
      _bodyElement,
      bodyClassName,
      name,
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  useEffect(setupStyledComponents, []);
  return (
    /*#__PURE__*/
    // Since HubStyle already applies global styles, we don't need duplicate global styles from Foundations Components
    _jsx(AppProvider, {
      applyGlobalStyles: false,
      children: /*#__PURE__*/_jsx(ComponentWithBodyClass, {
        bodyClassName: classNames('ui-app', bodyClassName),
        bodyElement: _bodyElement,
        children: /*#__PURE__*/_jsx("div", Object.assign({
          "data-application-name": name
        }, rest, {
          children: children
        }))
      })
    })
  );
}
UIApplication.propTypes = {
  _bodyElement: PropTypes.object,
  /**
   * The additional className(s) on the `<body>` element.
   */
  bodyClassName: PropTypes.string,
  /**
   * The `name` should match the `name` field of the app's static_conf. This
   * `name` value is used in the wrapper element's `data-application-name`
   * attribute.
   */
  name: PropTypes.string.isRequired,
  /**
   * The application's contents.
   */
  children: PropTypes.node
};
UIApplication.displayName = 'UIApplication';